import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, FileText, Building2, UserRound } from "lucide-react";

export default function Footer() {
  const loc = useLocation();
  const is = (p) => loc.pathname === p;

  const Item = ({ to, Icon, label }) => {
    const active = is(to);
    return (
      <Link
        to={to}
        className={[
          "relative flex flex-col items-center gap-0.5 py-2 rounded-xl select-none",
          "transform-gpu transition-transform duration-200 ease-out will-change-transform",
          active
            ? "text-white font-semibold scale-105"
            : "text-white/90 hover:text-white hover:scale-105",
        ].join(" ")}
      >
        <Icon size={18} strokeWidth={2} />
        <span className="text-[11px] leading-none">{label}</span>

        {/* Gạch chỉ báo cho tab active (không tô nền => không có vùng màu khác) */}
        {active && (
          <span className="absolute -bottom-0.5 h-0.5 w-10 rounded-full bg-white/85" />
        )}
      </Link>
    );
  };

  return (
    <footer className="fixed bottom-0 w-full z-20 text-white bg-gradient-to-r from-red-700 via-red-600 to-red-700 border-t border-red-800/40">
      <div className="grid grid-cols-4 gap-2 px-2 py-1">
        <Item to="/" Icon={Home} label="Trang chủ" />
        <Item to="/gioi-thieu" Icon={FileText} label="Giới thiệu" />
        <Item to="/noi-bo" Icon={Building2} label="Nội bộ" />
        <Item to="/ca-nhan" Icon={UserRound} label="Cá nhân" />
      </div>
    </footer>
  );
}
